import { Profile } from "@WahooFitness/cloud-client-types/Profile";

const FALLBACK_URL = "https://support.wahoofitness.com/";

// This is the default remote config for the settings service. This
// will get loaded in if Firebase is not reachable and there are no
// cached remote config settings.
// Make sure to add to this when you create a new remote config key.
//
// Keys where the default min profile is "std" should get removed and
// marked as deprecated in Firebase.
export const settingsDefaultRemoteConfig = {
  ELEMNT_MULTISPORT_PAGE_MIN_PROFILE: Profile.alpha,
  ELEMNT_PLANNED_WORKOUTS_MIN_PROFILE: Profile.alpha,
  CURATED_WORKOUTS_LIST: "[]",
  FITNESS_TEST_ID: "",
  FEATURES_IN_DEV: "{}",
  KICKR_RUN_ONBOARDING_VIDEO: "[]",
  SUPPORTED_SHARING_APPS: "[1,2,3,4,6,7,8,9,10,11,13,14,15,16,18,21]",
  HEART_RATE_ZONE_COUNT_CHOICES: "[5]",
  PACE_ZONE_COUNT_CHOICES: "[6, 7, 8]",
  POWER_ZONE_COUNT_CHOICES: "[6, 7, 8]",
  VENTILATION_ZONE_COUNT_CHOICES: "[5]",
  ROAM_1_SETUP_GUIDE_URL: FALLBACK_URL,
  ROAM_2_SETUP_GUIDE_URL: FALLBACK_URL,
  BOLT_1_SETUP_GUIDE_URL: FALLBACK_URL,
  BOLT_2_SETUP_GUIDE_URL: FALLBACK_URL,
  ACE_SETUP_GUIDE_URL: FALLBACK_URL,
  BOLT_3_SETUP_GUIDE_URL: FALLBACK_URL,
  ROAM_3_SETUP_GUIDE_URL: FALLBACK_URL,
  ELEMNT_WIFI_REQUIREMENTS_URL: FALLBACK_URL,
  KICKR_RUN_ONBOARDING_PLAN_GROUP_ID: "",
  SYSTM_TRAINING_PLANS_LINK: "https://systm.wahoofitness.com/training-plans",
  SUPPORTED_PARTNERS_PAGE_URL: FALLBACK_URL,
  STRAVA_LIVE_SEGMENT_SETTINGS_LEARN_MORE_URL: FALLBACK_URL,
  SUMMIT_SEGMENT_SETTINGS_CLIMB_SIZE_URL: FALLBACK_URL,
  SUMMIT_SEGMENT_SETTINGS_LEARN_MORE_URL: FALLBACK_URL,
  SHOW_RUNNING_ATHLETE_PROFILE_BETA_TAG: '[{ "minProfile": "alpha" }]',
  SHOW_VITAL_PRO_ZONES_MINPROFILE_VERSION: '[{ "minProfile": "alpha" }]',
  TIERED_SUBS_MINPROFILE_VERSION: '[{ "minProfile": "dev" }]',
  RECOVERY_247_MINPROFILE_VERSION: '[{ "minProfile": "dev" }]',
  DEBUG_DRAWER_FLAG: '[{ "minProfile": "dev" }]',
  RECOVERY_247_APPLE_HEALTH_MINPROFILE_VERSION: '[{ "minProfile": "dev" }]',
  ELEMNT_BIKE_BELL_MINPROFILE_VERSION: '[{ "minProfile": "dev" }]',
  // Features that release with Gen4 but apply to every ELEMNT the app supports; raise to beta, then std as Gen4 rolls out
  ELEMNT_GEN4_RELEASE_MINPROFILE_VERSION: '[{ "minProfile": "alpha" }]',
};

export type SettingsRemoteConfigKey = keyof typeof settingsDefaultRemoteConfig;
